export const TEST_PATTERNS = {
  SOLID: 'solid',
  CALIBRATION_GRID: 'calibrationGrid',
  CALIBRATION_GRID_INVERTED: 'calibrationGridInverted',
  COLOR_GRID: 'colorGrid',
  COLOR_BARS: 'colorbars',
  COLOR_BARS_ALT: 'colorBars',
  CROSSHATCH: 'crosshatch',
  CHECKERBOARD: 'checkerboard',
  FOCUS_RINGS: 'focusRings',
  TEST_CARD: 'testCard',
  NONE: 'none',
  SOURCE: 'source',
};

export const TEST_PATTERN_ARRAY = Object.values(TEST_PATTERNS);
